module.exports = __webpack_public_path__ + "img/hr-green-carpet-grass-06.32190742.png";